<section>

  <app-gjt></app-gjt>

  <div class="container title">
    <div class="row tl">
        <h1 class="col-sm ht">Registrar Usuario</h1>
    </div>
</div>


  <div class="container formul">
    <form class="regis-user" #formRegister='ngForm' (ngSubmit)='onSubmitRg()'>
        <div class="test">
            <div class="row">
                <mat-form-field appearance="outline" class="fsn col-sm">
                    <mat-label>Primer nombre</mat-label>
                    <input matInput placeholder="Madisson" name="firstname" firstname="ngModel" [(ngModel)]="user.firstname">
                  
                  </mat-form-field>
                 
                  <mat-form-field appearance="outline" class="fsn col-sm">
                    <mat-label>Segundo nombre</mat-label>
                    <input matInput placeholder="Hinata" name="middlename" middlename='ngModel' [(ngModel)]='user.middlename'>
                    
                  </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field appearance="outline" class="fsl col-sm">
                    <mat-label>Primer Apellido</mat-label>
                    <input matInput placeholder="Sánchez" name="firstlastname" firstlastname='ngModel' [(ngModel)]='user.firstlastname'>
                    
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="fsl col-sm">
                    <mat-label>Segundo Apellido</mat-label>
                    <input matInput placeholder="Orh" name="middlelastname" middlelastname='ngModel' [(ngModel)]='user.middlelastname'>
                    
                  </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field appearance="outline" class="uspw col-sm">
                    <mat-label>Usuario</mat-label>
                    <input matInput placeholder="mhsanchez" name="email" email='ngModel' [(ngModel)]='user.email'>
                    
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="uspw col-sm">
                    <mat-label>Contraseña</mat-label>
                    <input matInput placeholder="Contraseña" type="password" name="password" password='ngModel' [(ngModel)]='user.password'>
                    
                  </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field appearance="outline" class="rol col-sm-5">
                    <mat-label>Role</mat-label>
                    <mat-select name='rol' rol='ngModel' [(ngModel)]='user.rol'>
                        <mat-option value="Admin">Administrador</mat-option>
                        <mat-option value="User">Usuario</mat-option>
                      </mat-select>
                      
                  </mat-form-field>
                  <button mat-raised-button color="primary" type="submit" class="rol btn col-sm-2">Crear Usuario</button>
            </div>
        </div>
    </form>
  </div>

</section>
